// Image utilities: compression, base64 conversion

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

/**
 * Compress an image File client-side using canvas.
 * Resizes longest edge to maxSize and exports as JPEG (or PNG if has alpha).
 * Returns a data URL (base64).
 */
export async function compressImage(file, { maxSize = 1280, quality = 0.86 } = {}) {
  if (!file) return null;

  const dataUrl = await fileToBase64(file);
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // SVGs (and some sources) can report 0 intrinsic size — fall back to a square.
      let width = img.naturalWidth || img.width || maxSize;
      let height = img.naturalHeight || img.height || maxSize;
      const scale = Math.min(1, maxSize / Math.max(width, height));
      const w = Math.round(width * scale);
      const h = Math.round(height * scale);
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      // Black background so transparent areas don't render as black/garbage in JPEG.
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      // Always export a standard JPEG so every format (PNG/WEBP/GIF/SVG/…) is normalised.
      const out = canvas.toDataURL('image/jpeg', quality);
      resolve(out);
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}

export function dataUrlSizeKB(dataUrl) {
  if (!dataUrl) return 0;
  const base64 = dataUrl.split(',')[1] || '';
  return Math.round((base64.length * 3) / 4 / 1024);
}
